exports.Kategori = [
    { data: "Peralatan dan Perlengkapan Kantor", dataCode: "P-KTR" },
    { data: "Komputer", dataCode: "KOM" },
    { data: "Meubelair", dataCode: "MBL" },
    { data: "Peralatan Dapur", dataCode: "P-DPR" },
    { data: "Alat Komunikasi", dataCode: "A-KIS" },
    { data: "Alat Studio", dataCode: "A-STD" },
    { data: "Alat Ukur", dataCode: "A-UKR" },
    { data: "Kendaraan Bermotor", dataCode: "KB" },
    { data: "Alat Laboratorium", dataCode: "A-LAB" },
    { data: "Alat Keamanan", dataCode: "A-KEM" },
]

exports.Gedung = [
    { data: "A (Rektorat)", dataCode: "A" },
    { data: "B (Belajar)", dataCode: "B" },
    { data: "Musholah", dataCode: "MSHL" },
    { data: "Asrama", dataCode: "ASRM" },
]

exports.Ruangan = {
    0: [
        { data: "Rektor", dataCode: "REKTOR"},
        { data: "Wakil Rektor", dataCode: "WAREK"},
        { data: "Dosen", dataCode: "DOSEN"},
        { data: "P5I", dataCode: "P5I"},
        { data: "BAUK", dataCode: "BAUK"},
        { data: "BAAK", dataCode: "BAAK"},
        { data: "Fakultas Hukum", dataCode: "FH"},
        { data: "Fakultas Keguruan dan Ilmu Pengetahuan", dataCode: "FKIP"},
        { data: "Fakultas Teknik", dataCode: "FT"},
        { data: "Fakultas Perikanan", dataCode: "FPi"},
        { data: "Dapur", dataCode: "DPR"},
        { data: "Lab Bahasa", dataCode: "LAB-BHS"},
        { data: "Lab Hukum ", dataCode: "LAB-HKM"},
        { data: "Lab Perikanan", dataCode: "LAB-PRKN"},
        { data: "Lab Fisika", dataCode: "LAB-FSK"},
        { data: "LPM", dataCode: "LPM"},
        { data: "LPPM", dataCode: "LPPM"},
        { data: "BKBH", dataCode: "BKBH"},
        { data: "Staf Prodi", dataCode: "PRDI"},
        { data: "Lab Komputer", dataCode: "LAB-KOM"},
        { data: "Microteaching", dataCode: "MCTH"},
        { data: "Lab Kebidanan", dataCode: "LAB-KBDN"},
        { data: "Lab Teknik Sipil", dataCode: "LAB-SIPIL"},
        { data: "ITC", dataCode: "ITC"},
    ],
    1: [
        { data: "Pengawas", dataCode: "PGWS"},
        { data: "Gudang", dataCode: "GDNG"},
        { data: "Aula", dataCode: "AULA"},
        { data: "Kelas Bahasa Inggris (1)", dataCode: "RK1-BIng"},
        { data: "UKM Pramuka", dataCode: "UKM-Prmk"},
        { data: "Kelas Bahasa Inggris (2)", dataCode: "RK2-Bing"},
        { data: "Kelas Bahasa Indonesia (3)", dataCode: "RK3-BInd"},
        { data: "Kelas Bahasa Indonesia (4)", dataCode: "RK4-BInd"},
        { data: "Kelas PKN (5)", dataCode: "RK5-Pkn"},
        { data: "Perpustakaan", dataCode: "PSTK"},
        { data: "Kelas PKN (6)", dataCode: "RK6-Pkn"},
        { data: "Kelas Hukum (7)", dataCode: "RK7-Hkm"},
        { data: "Kelas Hukum (8)", dataCode: "RK8-Hkm"},
        { data: "Kelas Perikanan (9)", dataCode: "RK9-Prkn"},
        { data: "Kelas Perikanan (10)", dataCode: "RK10-Prkn"},
        { data: "Kelas Hukum (11)", dataCode: "RK11-Hkm"},
        { data: "Kelas Kebidanan (12)", dataCode: "RK12-Kbdn"},
        { data: "Kelas Teknik Sipil (13)", dataCode: "RK13-Spl"},
        { data: "Kelas Teknik Sipil (14)", dataCode: "RK14-Spl"},
        { data: "Kelas Teknik Mesin (15)", dataCode: "RK15-Msn"},
        { data: "UKM HMPS", dataCode: "HMPS"},
        { data: "Lab Teknik Mesin", dataCode: "LAB-MSN"},
    ],
    2: [
        { data: "Musholah", dataCode: "MSHL"},
    ],
    3: [
        { data: "Asrama", dataCode: "ASRM"},
    ]
}

exports.RuanganFilter = [
        { data: "Rektor", dataCode: "REKTOR"},
        { data: "Wakil Rektor", dataCode: "WAREK"},
        { data: "Dosen", dataCode: "DOSEN"},
        { data: "P5I", dataCode: "P5I"},
        { data: "BAUK", dataCode: "BAUK"},
        { data: "BAAK", dataCode: "BAAK"},
        { data: "Fakultas Hukum", dataCode: "FH"},
        { data: "Fakultas Keguruan dan Ilmu Pengetahuan", dataCode: "FKIP"},
        { data: "Fakultas Teknik", dataCode: "FT"},
        { data: "Fakultas Perikanan", dataCode: "FPi"},
        { data: "Dapur", dataCode: "DPR"},
        { data: "Lab Bahasa", dataCode: "LAB-BHS"},
        { data: "Lab Hukum ", dataCode: "LAB-HKM"},
        { data: "Lab Perikanan", dataCode: "LAB-PRKN"},
        { data: "Lab Fisika", dataCode: "LAB-FSK"},
        { data: "LPM", dataCode: "LPM"},
        { data: "LPPM", dataCode: "LPPM"},
        { data: "BKBH", dataCode: "BKBH"},
        { data: "Staf Prodi", dataCode: "PRDI"},
        { data: "Lab Komputer", dataCode: "LAB-KOM"},
        { data: "Microteaching", dataCode: "MCTH"},
        { data: "Lab Kebidanan", dataCode: "LAB-KBDN"},
        { data: "Lab Teknik Sipil", dataCode: "LAB-SIPIL"},
        { data: "ITC", dataCode: "ITC"},
        { data: "Pengawas", dataCode: "PGWS"},
        { data: "Gudang", dataCode: "GDNG"},
        { data: "Aula", dataCode: "AULA"},
        { data: "Kelas Bahasa Inggris (1)", dataCode: "RK1-BIng"},
        { data: "UKM Pramuka", dataCode: "UKM-Prmk"},
        { data: "Kelas Bahasa Inggris (2)", dataCode: "RK2-Bing"},
        { data: "Kelas Bahasa Indonesia (3)", dataCode: "RK3-BInd"},
        { data: "Kelas Bahasa Indonesia (4)", dataCode: "RK4-BInd"},
        { data: "Kelas PKN (5)", dataCode: "RK5-Pkn"},
        { data: "Perpustakaan", dataCode: "PSTK"},
        { data: "Kelas PKN (6)", dataCode: "RK6-Pkn"},
        { data: "Kelas Hukum (7)", dataCode: "RK7-Hkm"},
        { data: "Kelas Hukum (8)", dataCode: "RK8-Hkm"},
        { data: "Kelas Perikanan (9)", dataCode: "RK9-Prkn"},
        { data: "Kelas Perikanan (10)", dataCode: "RK10-Prkn"},
        { data: "Kelas Hukum (11)", dataCode: "RK11-Hkm"},
        { data: "Kelas Kebidanan (12)", dataCode: "RK12-Kbdn"},
        { data: "Kelas Teknik Sipil (13)", dataCode: "RK13-Spl"},
        { data: "Kelas Teknik Sipil (14)", dataCode: "RK14-Spl"},
        { data: "Kelas Teknik Mesin (15)", dataCode: "RK15-Msn"},
        { data: "UKM HMPS", dataCode: "HMPS"},
        { data: "Lab Teknik Mesin", dataCode: "LAB-MSN"},
        { data: "Musholah", dataCode: "MSHL"},
        { data: "Asrama", dataCode: "ASRM"},
]

exports.Valuasi ={
    clientId: "e2c08366-7e45-413e-a2a8-a869cc43c5a5",
    clientSecret: "427a9c94-829c-4ee0-a34b-e458414dec99",
    publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4SwPfnmkntbiXqTl4UKTs0ZSxVmQGzUSMPZqcm8eYGyq4GcHJ4tkmWao9FjRPL3QwtH3brCdQvbwrjTbN274KIucSUmXxrcSr5zPxxErNRM2aLyXF1D2FZLuzZQL6LxXQNMiKnugbzDOQ3Xvv7CxUV9oxDx7Ds08NHD3eKUTit1gwBxzw8/1DFdKBTNTdwUNJ16OjURQY5pMPoduuJ01zImdqx+QUZwnJxU89m2jNiqqxD6X+lxrRou3E0mnE/MdJ/bfYEygEYVaj/CXbD/EWyu+ugQ+jZRFDEflPQxcGtIRpOkwtBhmFZQ569emc3KDvaq1x324k9Kxxf1NcpN4nwIDAQAB",
    privatKey: "MIIEowIBAAKCAQEA4SwPfnmkntbiXqTl4UKTs0ZSxVmQGzUSMPZqcm8eYGyq4GcHJ4tkmWao9FjRPL3QwtH3brCdQvbwrjTbN274KIucSUmXxrcSr5zPxxErNRM2aLyXF1D2FZLuzZQL6LxXQNMiKnugbzDOQ3Xvv7CxUV9oxDx7Ds08NHD3eKUTit1gwBxzw8/1DFdKBTNTdwUNJ16OjURQY5pMPoduuJ01zImdqx+QUZwnJxU89m2jNiqqxD6X+lxrRou3E0mnE/MdJ/bfYEygEYVaj/CXbD/EWyu+ugQ+jZRFDEflPQxcGtIRpOkwtBhmFZQ569emc3KDvaq1x324k9Kxxf1NcpN4nwIDAQABAoIBAHHU32RVxHYUNc4Y2Km/CYII3BEujN5kPvUHrZp6OEYQyXW2P/Sq0EmIj4MvX1+wqdfDY63OlUHkKpo22Fe2vrdolLKsBJGNvWGQCa4eLNShCNF7/XnpEO6pIBZHcJnQlN+NnOkTJHDxoGSUO4aRoaJ8dC84UBGUiYoNTd3svetlucZUrfLVZddXzYtoPzIcGJOLswD0eDVl2+8E5Ogn35IiYCzL8Ba8BAf7FlJak/xcgsIOhgVUw3yRgbysJHbX+NP2cZcnrw1QvpwbPS661okt/T5aLhdBI8i8IceDTZRVA+ZGXWPU5j22vkeZM1ffe5bTAFv+82JLxKuxU2VrFVECgYEA/YCAdWeIKfGEV8uDVQpAEyaxRBNh6HVzGkp7Ph/oSQyBfvoIqXdzpQfA4R8nylZSfuQSGWMS6L1tB6ALRrYxyjbaZVjOmK6UBbUeHAil7a22mlIuixMp1s4oAy5J0FYMF97H1FfBugHea7yKX7ZpNmhKvk2XLJMC4FZQTEOlUKkCgYEA42QXnzMf0SBEOTP6maPgHapB0ifMQG5vQuowfcus0kcXNUisygKbljxL+QSlX0rD9PbD3SlhoIF2agu2OjQC1dAZjTfgRF/8IGPoBblam3dXj3OTji1UlCLpOgf7mcfETBIpNsKUJZffCUUOnovfFCbshIPtfY1NGDn/PcmSpAcCgYEAt2OmCskqPUWmeykUSooOzov4Q4pOEzAcY9GsFMZacbYlXGmfqJFszN+uDm5Oh9co+PkfitQcktiurox+e9pEbMh/+D9lvhjVpsdfD+LFvwsjhcKcPypO40HiumJbLeeB+ibFo30U/e5qLMCJzjIVLTIHmGJjUfDMbOSkVHe/eXkCgYAfwf3ulRRPf8MnfhP020dUvU+eC0LiiMnvPYfyObz0TUt3fKPtPrn+HIO7zqNOEMIXd1NZkwr4gLxKCUK1FEiFFiBLcc9XnVQ4Ldvc2MtHxT4sYcbs53XVjp6mJTFFg/ntaefppvlL2s8im0t0ZzKLvPfxdf94NoDa7lawiXN6hwKBgD9WwTa+jOOMDVBxXShq9b1g2i/w/qHXGUetSgsdODVbcU/KJoWJ9wQMV5WqtyyjrNS465sESTL9aQ/E+dqcg7gyQgMkkxX1wPy0U4cCopwtEVURVLKAkuRWa7BoT2IvAre9plyiQvjreD1nkd93VR8IZ5zK3dFOz4xoE2KG08uw",
    providerCode: "90168"
}

/*
exports.Valuasi ={
    clientId: "3d781d9f32e45e6b986dfbae60d26952",
    clientSecret: "cb0b074108332b95ffa85b0799cb8dcf25e6d66554384c56975a3108ea001565",
    publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgsszddmjf8dIYQkj4NOU6MsEDND/vUvWEpNMNa0W+V87eCMYZ6ImMh15qHzZkkf6rFPqUrEPeyVUFvnrCVNtpIlOtJeLl46RjMASq7FTnculFb4VzKdG/d3q21nqVWnGNAx5AVf3H7/4YBQlyrHCTSuyLjdBYbCiVQIAlvuCn/fhrc5kioXVZBGn2OAslYYYFUEdKb73zKPrA5m8bWyY3SNp0wuOeL9A2BDr9+9zuBdGqhv31I133COQy0mCpDpSTvX9NKqdp9bl58Abl9PtCoyEAJ5/OfH1XREDWLf9Qtr8c+M/WYnOTwV563GPG8DdPQSg+neEOHZNO4Tvn+5T7wIDAQAB",
    privatKey: "MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCCyzN12aN/x0hhCSPg05ToywQM0P+9S9YSk0w1rRb5Xzt4IxhnoiYyHXmofNmSR/qsU+pSsQ97JVQW+esJU22kiU60l4uXjpGMwBKrsVOdy6UVvhXMp0b93erbWepVacY0DHkBV/cfv/hgFCXKscJNK7IuN0FhsKJVAgCW+4Kf9+GtzmSKhdVkEafY4CyVhhgVQR0pvvfMo+sDmbxtbJjdI2nTC454v0DYEOv373O4F0aqG/fUjXfcI5DLSYKkOlJO9f00qp2n1uXnwBuX0+0KjIQAnn858fVdEQNYt/1C2vxz4z9Zic5PBXnrcY8bwN09BKD6d4Q4dk07hO+f7lPvAgMBAAECggEAKgLP6DI8aI4fqv9vFUeQxId1KRK2mlxyCexjJbiPsRDMPsXzEFKOdzlteteDYQ+armCT2vTBdroiPPEQdCHmjVuHOs2Uil1CVhXZyWk/ZOdlAstYIDC4xlFSHxvN/5pmjhBVi79wArQ8OMwv6V/Ye8YlyN95skG0mp52hwiJSA020/jav+4aOGswmn8SvWlua97jYFzNUMN7v7bWgArG+vzP5EmDzukUrzXjUakcU/a7srmsA5c/oAaY4P9IhXFI6GpmWU0M61FWYlz1zlu9/u3nV7CEHbpQ0LSAVU8w7vzvRxUpgEQGMQJCcsBdbOaRFxFt9Xqj4SDesvjja8X3TQKBgQC4Ec8O1LyNROnbgceannBhl9WtDh3xsQl43r23Dyti/kfRwYIyi5cimTEXUq7dZclC3+q4Pf1dpT8yyDiK1xXaIzecQ65xkpvMbN/TtOsNHjDALIwB4KESyvBmGGlhSM8OXYc2JvY8pfuWhSifXRtQgvk4V2wRjhEBMU37pLRrbQKBgQC157eTI5wsg/R1lGknWQwrFo/y8pObnHKqlPRdek6sMjOD3hPTYYjzZ3Sazl07rUat+w08b2gYbGL5D3mPd6a/mPETXMcAKH26fHV9sJqpWQCFon4bU472Jm+ToL0/zGtU532pJJjH1QUzXZeGvD6zyXb7B2E3es5GXlz9FQJnSwKBgA1Jo9PjQZVFI0ioTrt3so8pAdDTUxAOgquKENH1M2GbD54xxO9XKlriCiwv2NW8slG0jmIsf2zSMAS/dW14Z2hu4GXUcPRb7AlO1r2Wst0oj8ZfsN+10orjwYTtQDY4plHYKJmdKGtqZAYSqMMQWpduTQVnMjL2OX4HjCSdWDTlAoGAZm/I1xlUl1Tv007yMHBbA+C+y4eDTDw77ofXXNTFfP8AN6BV9dGVN8zow0y3ACZCCTO5bnEmY6qVyb/HKt2sj3TnPYofnp0uwFfaKh/L2NYAD0FEVsslVMSsTKxWJplNUBDUmO29A7uYJCbub7eOb9xiHlc3jfCgPMxi/TpZkiUCgYB41pP6Yrundc7L3uzH23i/3/ni12WYlhauuthCdxEm0V0asWx4BrrM2xbcYi2j4tw2UEe22HktB3vGToKYbIe05GnlkZuDiFDvDbgo4JlnHLi8ifmqsbKlHaZoc6zCWcRbbWqKQCz27EpoRvgtusjMK/KZN9SUkoog/qunyYzrMA==",
    providerCode: "90168"
}
*/
/*
exports.DataAPi = {
    urlGetAll: "http://localhost:4524/api/aset",
    urlGetOne: "http://localhost:4524/api/aset/find/",
    urlGetFilter: "http://localhost:4524/api/aset/filter/",
    urlPutUpdate: "http://localhost:4524/api/aset/update/",
    urlPostCreate: "http://localhost:4524/api/aset/create",
    urlPostImage: "http://localhost:4524/api/upload",
    urlDelete: "http://localhost:4524/api/aset/delete/",
    urlQrcode: "http://localhost:3000/#/rincian/aset/",
    urlTestApi: "http://localhost:4524/api/test/",
    urlApiAuthUser: "http://localhost:4524/api/auth/",

    //urlApiAspi: "https://mitratest.banksumselbabel.com/",
    //urlApiSignatureAuth: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-auth",
    //urlApiGetTokenb2b: "https://mitratest.banksumselbabel.com:8065/1.0/access-token/b2b",
    //urlApiSignatureService: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-service",

    urlApiAspi: "http://localhost:4524/",
    urlApiSignatureAuth: "http://localhost:4524/api/auth/signatureAuth",
    urlApiGetTokenb2b: "http://localhost:4524/api/auth/accessToken",
    urlApiSignatureService: "http://localhost:4524/api/auth/serviceAuth",
}
*/
exports.EndPoint = {
    getReport: "bsb-va/v1.0/transfer-va/report",
    createVA: "bsb-va/v1.0/transfer-va/create-va",
    updateVA: "bsb-va/v1.0/transfer-va/update-va",
    deleteVA: "bsb-va/v1.0/transfer-va/delete-va",
    inquiryVA: "bsb-va/v1.0/transfer-va/inquiry-va",
    notifBank: "api/notify-intra-bank",
}


exports.DataAPi = {
    urlGetAll: "https://api-sinergi.uniski.ac.id/api/aset",
    urlGetOne: "https://api-sinergi.uniski.ac.id/api/aset/find/",
    urlGetFilter: "https://api-sinergi.uniski.ac.id/api/aset/filter/",
    urlPutUpdate: "https://api-sinergi.uniski.ac.id/api/aset/update/",
    urlPostCreate: "https://api-sinergi.uniski.ac.id/api/aset/create",
    urlPostImage: "https://api-sinergi.uniski.ac.id/api/upload",
    urlDelete: "https://api-sinergi.uniski.ac.id/api/aset/delete/",
    urlQrcode: "https://api-sinergi.uniski.ac.id/#/rincian/aset/",
    urlTestApi: "https://api-sinergi.uniski.ac.id/api/test/",
    urlApiAuthUser: "https://api-sinergi.uniski.ac.id/api/auth/",
    urlApiAspi: "https://mitratest.banksumselbabel.com:8065/",
    urlApiSignatureAuth: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-auth",
    urlApiGetTokenb2b: "https://mitratest.banksumselbabel.com:8065/1.0/access-token/b2b",
    urlApiSignatureService: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-service",

    urlApiAspi: "https://mitratest.banksumselbabel.com/",
    urlApiSignatureAuth: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-auth",
    urlApiGetTokenb2b: "https://mitratest.banksumselbabel.com:8065/1.0/access-token/b2b",
    urlApiSignatureService: "https://mitratest.banksumselbabel.com:8065/1.0/utilities/signature-service",

    //urlApiAspi: "http://localhost:4524/",
    //urlApiSignatureAuth: "http://localhost:4524/api/auth/signatureAuth",
    //urlApiGetTokenb2b: "http://localhost:4524/api/auth/accessToken",
    //urlApiSignatureService: "http://localhost:4524/api/auth/serviceAuth",
}


/*
exports.DataAPi = {
    urlGetAll: "https://212.85.27.159:4524/api/aset",
    urlGetOne: "https://212.85.27.159:4524/api/aset/find/",
    urlGetFilter: "https://212.85.27.159:4524/api/aset/filter/",
    urlPutUpdate: "https://212.85.27.159:4524/api/aset/update/",
    urlPostCreate: "https://212.85.27.159:4524/api/aset/create",
    urlPostImage: "https://212.85.27.159:4524/api/upload",
    urlDelete: "https://212.85.27.159:4524/api/aset/delete/",
    urlQrcode: "https://212.85.27.159:4524/#/rincian/aset/",
    urlTestApi: "https://212.85.27.159:4524/api/test/",
    urlApiAuthUser: "https://212.85.27.159:4524/api/auth/",
}
*/